import app from './app/app.js'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'


import mediaQueries from './plugins/media-queries.js'
import vh from './plugins/vh.js'
import vw from './plugins/vw.js'
import barba from './plugins/barba.js'
import imagesTransitions from './plugins/images-transitions.js'

import AboutComponent from './components/about.js'
import BackgroundComponent from './components/background.js'
import CollectionComponent from './components/collection'
import CollectionslistComponent from './components/collectionslist'
import ContactsComponent from './components/contacts'
import ContactformoverlayComponent from './components/contactformoverlay'
import FooterComponent from './components/footer'
import GalleryComponent from './components/gallery.js'
import HomeComponent from './components/home.js'
import LoaderComponent from './components/loader.js'
import MobilenavComponent from './components/mobilenav.js'
import MosaiqgroupComponent from './components/mosaiqgroup.js'
import NewsComponent from './components/news.js'
import PostComponent from './components/post'
import ProductbottomComponent from './components/productbottom'
import ProductIntroComponent from './components/productintro'
import ProductslistComponent from './components/productslist'
import RelatedComponent from './components/related'
import TopComponent from './components/top'

app
  .addComponent('about', AboutComponent)
  .addComponent('background', BackgroundComponent)
  .addComponent('collection', CollectionComponent)
  .addComponent('collectionslist', CollectionslistComponent)
  .addComponent('contacts', ContactsComponent)
  .addComponent('contactformoverlay', ContactformoverlayComponent)
  .addComponent('footer', FooterComponent)
  .addComponent('gallery', GalleryComponent)
  .addComponent('home', HomeComponent)
  .addComponent('loader', LoaderComponent)
  .addComponent('mobilenav', MobilenavComponent)
  .addComponent('mosaiqgroup', MosaiqgroupComponent)
  .addComponent('news', NewsComponent)
  .addComponent('post', PostComponent)
  .addComponent('productbottom', ProductbottomComponent)
  .addComponent('productintro', ProductIntroComponent)
  .addComponent('productslist', ProductslistComponent)
  .addComponent('related', RelatedComponent)
  .addComponent('top', TopComponent)
  .init()

// media queries
mediaQueries.add('small', '(max-width: 720px)')
// mediaQueries.add('medium', '(min-width: 721px) and (max-width: 1024px)')
// mediaQueries.add('large', '(min-width: 1025px) and (max-width: 1640px)')
// mediaQueries.add('wide', '(min-width: 1641px)')

// vh
vh.init()
vw.init()
barba.init()
imagesTransitions.init()

gsap.registerPlugin(ScrollTrigger)

let contactOverlay = document.querySelector('.cm-contactformoverlay');
let contactTrigger = document.querySelector('.contact-trigger');

if(contactOverlay && contactTrigger) {
	contactTrigger.addEventListener('click', () => {
		contactOverlay.classList.add('cm-contactformoverlay--active');
		const header = document.getElementById('head');
		if (header) {
			gsap.to(header, { autoAlpha: 0, duration: 0.3 });
		}
	});
}


function isInViewport(el) {
	const item = el.getBoundingClientRect();
	return (
		item.top >= 0 &&
		item.left >= 0 &&
		item.bottom <= (
			window.innerHeight ||
			document.documentElement.clientHeight) &&
		item.right <= (
			window.innerWidth ||
			document.documentElement.clientWidth)
	);
}

const footer = document.querySelector('.cm-footer__content');

if(footer) {
	window.addEventListener('scroll', () => {
		if(isInViewport(footer)) {
			contactTrigger.classList.add('invert');
		} else {
			contactTrigger.classList.remove('invert');
		}
	});

}

let overlay = document.querySelector('.overlay');
if(overlay) {
	overlay.querySelector('.overlay__close').addEventListener('click', () => {
		overlay.classList.remove('show');
		localStorage.setItem('newsletter', 'closed');
	});
}

if(localStorage.getItem('newsletter') === null) {
	console.log('newsletter');
	setTimeout(() => {
		overlay.classList.add('show');
	}, 3000)
}


let htmltag = document.querySelector('html');
const lang = htmltag.getAttribute('lang');
let nlfooterLang = document.querySelectorAll('input[name="LANG"]');
let overlayTitle = document.querySelector('.overlay__title');
let overlayText = document.querySelector('.overlay__text');
let overlayInput = document.querySelector('.overlay__content .cm-footer__nl__input input');
let overlayPrivacy = document.querySelector('.overlay__content .cm-footer__nl__privacy a');
let overlaySubmit = document.querySelector('.overlay__content .cm-footer__nl__submit input');

let footerTitle = document.querySelector('.cm-footer .cm-footer__nl__label');
let footerInput = document.querySelector('.cm-footer .cm-footer__nl__input input');
let footerPrivacy = document.querySelector('.cm-footer .cm-footer__nl__privacy a');
let footerSubmit = document.querySelector('.cm-footer .cm-footer__nl__submit input');

if(lang == 'it-IT') {
	overlayTitle.innerHTML = 'Benvenuti!';
	overlayText.innerHTML = 'Resta aggionato su news ed eventi!';
	overlayInput.placeholder = 'Inserisci la tua email';
	overlayPrivacy.innerHTML = 'Ho letto e accetto i termini della privacy policy';
	overlaySubmit.value = 'Iscriviti';
	if (footerTitle) footerTitle.innerHTML = 'Resta aggiornato su news ed eventi!';
	if (footerInput) footerInput.placeholder = 'Inserisci la tua email';
	if (footerPrivacy) footerPrivacy.innerHTML = 'Ho letto e accetto i termini della privacy policy';
	if (footerSubmit) footerSubmit.value = 'Iscriviti';
} else {
	overlayTitle.innerHTML = 'Welcome!';
	overlayText.innerHTML = 'Stay updated with our news and events!';
	overlayInput.placeholder = 'Your Email address';
	overlayPrivacy.innerHTML = 'I\'ve read and accept the privacy policy terms';
	overlaySubmit.value = 'Subscribe';
	if (footerTitle) footerTitle.innerHTML = 'Stay updated with our news and events!';
	if (footerInput) footerInput.placeholder = 'Your Email address';
	if (footerPrivacy) footerPrivacy.innerHTML = 'I\'ve read and accept the privacy policy terms';
	if (footerSubmit) footerSubmit.value = 'Subscribe';
}
nlfooterLang.forEach(nlang => {
	if(lang == 'it-IT') {
		nlang.value = 'it';
	} else {
		nlang.value = 'en';
	}
})


// let triggerNl = document.querySelector('.open-newsletter');
// if(triggerNl) {
// 	triggerNl.addEventListener('click', () => {
// 		overlay.classList.add('show');
// 	});
// }


let menuItem = document.querySelectorAll('.menu-item');
menuItem.forEach(item => {
	item.querySelector('a').classList.add('no-barba');
})
